interface ResolveMediaAspectRatioParams {
  width: number
  height: number
  isVideo: boolean
  isWeb: boolean
  orientation?: string
  fallbackAspectRatio: number
}

function isPositiveFiniteNumber(value: number): boolean {
  return Number.isFinite(value) && value > 0
}

function normalizeVideoOrientation(orientation?: string): string | null {
  if (orientation == null) return null

  const normalized = orientation.trim().toLowerCase()
  if (normalized.length === 0) return null

  if (
    normalized === 'portrait' ||
    normalized === 'portrait-upside-down' ||
    normalized === 'landscape' ||
    normalized === 'landscape-left' ||
    normalized === 'landscape-right' ||
    normalized === 'square' ||
    normalized === 'unknown'
  ) {
    return normalized
  }

  return null
}

function calculateRatio(
  width: number,
  height: number,
  fallbackAspectRatio: number,
): number {
  if (!isPositiveFiniteNumber(width) || !isPositiveFiniteNumber(height)) {
    return fallbackAspectRatio
  }

  const ratio = width / height
  if (!isPositiveFiniteNumber(ratio)) {
    return fallbackAspectRatio
  }

  return ratio
}

export function resolveMediaAspectRatio({
  width,
  height,
  isVideo,
  isWeb,
  orientation,
  fallbackAspectRatio,
}: ResolveMediaAspectRatioParams): number {
  const rawRatio = calculateRatio(width, height, fallbackAspectRatio)

  if (!isVideo || isWeb) {
    return rawRatio
  }

  const normalizedOrientation = normalizeVideoOrientation(orientation)
  if (normalizedOrientation == null || normalizedOrientation === 'unknown') {
    return rawRatio
  }

  if (normalizedOrientation === 'square') {
    return 1
  }

  let correctedWidth = width
  let correctedHeight = height

  if (
    (normalizedOrientation === 'landscape' ||
      normalizedOrientation === 'landscape-left' ||
      normalizedOrientation === 'landscape-right') &&
    width < height
  ) {
    correctedWidth = height
    correctedHeight = width
  }

  if (
    (normalizedOrientation === 'portrait' ||
      normalizedOrientation === 'portrait-upside-down') &&
    width > height
  ) {
    correctedWidth = height
    correctedHeight = width
  }

  return calculateRatio(correctedWidth, correctedHeight, fallbackAspectRatio)
}
